import { SharedModule } from 'src/app/shared/shared.module';
import { MobileLogoutModule } from './mobile-logout/mobile-logout.module';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { ValueAddServiceModule } from './value-add-service/value-add-service.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BnNgIdleService } from 'bn-ng-idle';

import { DatePipe } from '@angular/common';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ConfirmationDialogService } from './services/confirmation-dialog.service';
import { DisabledRightClickDirective } from './directive/disabled-right-click.directive';
import { ClientFilterPipe } from './filters/client-filter.pipe';
import { GroupByWithSumPipe } from './filters/group-by-with-sum.pipe';
// import { YesPaymentSuccessModule } from './yes-payment-success/yes-payment-success.module';
// import { YesLogoutModule } from './yes-logout/yes-logout.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { MPINLoginComponent } from './mpinlogin/mpinlogin.component';
import { ClientPdfschedulerComponent } from './client-pdfscheduler/client-pdfscheduler.component';
import { SitedisclaimerComponent } from './sitedisclaimer/sitedisclaimer.component';
import { IfaModule } from './ifa/ifa.module';
import { NomineePopUpComponent } from './nominee-pop-up/nominee-pop-up.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './services/reuse-strategy';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ConfigService } from './config.service';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { HelpPolicyComponent } from './help-policy/help-policy.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { LegalSectionComponent } from './legal-section/legal-section.component';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    DisabledRightClickDirective,
    ClientFilterPipe,
    GroupByWithSumPipe,
    PrivacyPolicyComponent,
    DeleteAccountComponent,
    MPINLoginComponent,
    ClientPdfschedulerComponent,
    SitedisclaimerComponent,
    TermsConditionComponent,
    HelpPolicyComponent,
    DisclaimerComponent,
    LegalSectionComponent
  ],
  imports: [
    ValueAddServiceModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MobileLogoutModule,
    IfaModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    NgxDatatableModule
    // YesPaymentSuccessModule,
    // YesLogoutModule,
  ],
  providers: [
    ConfirmationDialogService
    , DatePipe
    , BnNgIdleService
    , CustomReuseStrategy, {
      provide: RouteReuseStrategy,
      useExisting: CustomReuseStrategy
    }
    , {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [ConfigService],
      multi: true
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }

export function initApp(configService: ConfigService) {
  return () => {
    return configService.loadConfig()
  }
}
